import { render } from "./AddCompanySettingModal.vue?vue&type=template&id=3df2a9b2&ts=true"
import script from "./AddCompanySettingModal.vue?vue&type=script&lang=ts"
export * from "./AddCompanySettingModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__